<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :has-buttons="false"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
  >
    <template #greyTabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" has-border cols="auto">
        <v-tab-item>
          <failure-email-status-tab />
        </v-tab-item>
        <v-tab-item>
          <admin-input-row translation-path="admin.zdmFailureDictsTitle" name="dicts" align="baseline">
            <template #dicts.input>
              <ZDMFailureStatusDictionaryList />
            </template>
          </admin-input-row>
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminInputRow from '@/components/AdminInputRow';
import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import FailureEmailStatusTab from '@/components/FailureStatusEmailTab';
import ZDMFailureStatusDictionaryList from '@/components/ZDMFailureStatusDictionaryList';

export default {
  name: 'ZDMFailureStatusAdmin',
  components: {
    ZDMFailureStatusDictionaryList,
    FailureEmailStatusTab,
    GreyTabs,
    AdminWrapper,
    AdminInputRow,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@ZDM_FAILURES_STATUS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@zdm_failures_status_module_enabled'),
    tabs() {
      return [
        { name: this.$i18n.t('admin.emailSendTabName') },
        {
          name: this.$i18n.t('admin.zdmFailuresDescriptionsDictsTabName'),
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'zdm_failures_status_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'greyTabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
